/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

// Defensive guard against environment-file inversion. A prod bundle pointing
// at a dev-shaped realm (realm name conventionally starts with `dev.`) would
// silently log users into the dev IDP and round-trip their tokens through the
// wrong audience. Fail loudly at bootstrap instead.
if (environment.production && environment.keycloak.realm.startsWith('dev.')) {
  throw new Error(
    `Bootstrap aborted : production bundle is pointing at dev realm "${environment.keycloak.realm}". ` +
    `Check environment.ts vs environment.development.ts before deploying.`
  );
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
